export default "__VITE_ASSET__bac4143d__"